import React, { useState } from "react";

import { CUSTOM_SCOPES, FILTER_KEYS } from "../../../../config/constants";
import {
  buildPeriodTypesFilter,
  isIn,
  text_truncate,
} from "../../../../helpers";
import { SimpleMultiSelectorPresentational } from "../SimpleMultiSelector";
import { PeriodTypeInlineMultiSelectorPropsType } from "./types";

import "./styles.scss";
import { useSelector } from "react-redux";
import { selectPeriodTypesByTeam } from "store/hooks/periodTypes";

export const PeriodTypeInlineMultiSelector = ({
  league,
  changeItemsSelected,
  selectedItems,
  editable,
  id,
  teamId,
}: PeriodTypeInlineMultiSelectorPropsType) => {
  const [show, setShow] = useState(false);
  const periodTypes = useSelector(selectPeriodTypesByTeam(teamId));
  const periodTypesFilter = buildPeriodTypesFilter(periodTypes);
  if (editable) {
    return (
      <div
        className="period-type-simple-multi-selector"
        title={selectedItems.length ? selectedItems.join("\n") : ""}
      >
        <SimpleMultiSelectorPresentational
          show={show}
          close={() => setShow(false)}
          open={() => setShow(true)}
          filterData={selectedItems.map((type: any) => ({
            value: type,
            name: type,
          }))}
          changeFilterData={changeItemsSelected}
          type={{
            name: "Period Type",
            types: [
               ...selectedItems
                .filter(
                  (selItem: any) => !isIn(periodTypesFilter.types, selItem)
                )
                .map((type: any) => ({ value: type, name: type })),
              ...periodTypesFilter.types.map((type) => ({
                value: type,
                name: type,
              })),
             
            ],
            title: "PERIOD TYPE " + id,
            filterKey: FILTER_KEYS.PERIOD_TYPE,
          }}
          forceScope={CUSTOM_SCOPES.PERIOD_TYPE_PRACTICE_MANAGER_TAB}
        />
      </div>
    );
  } else {
    return (
      <div
        title={selectedItems.length ? selectedItems.join("\n") : ""}
        className="period-type-inline-multi-selector"
      >
        {selectedItems.length === 0
          ? ""
          : selectedItems.length === 1
          ? text_truncate(selectedItems[0], 30, "...")
          : selectedItems.length === 2
          ? text_truncate(selectedItems[0], 26, "...") + " (+1) "
          : "Multiple (" + selectedItems.length + ")"}
      </div>
    );
  }
};

export * from "./types";
